import { buildHiddenSubfieldLookup, instanceHasContent } from './formConfigEmptyInstanceFilter';
export function filterEmptyPreviewFields(fields, config) {
    var hiddenLookup = buildHiddenSubfieldLookup(config);
    return fields.filter(function (field) {
        return instanceHasContent(field.fieldTag, field.subfields, hiddenLookup);
    });
}
